/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/12/2021
 */

import {Type} from "@qwoach/class-transformer-wrapper";
import BaseObject from "@shared/BaseObject";
import WatchChannel from "./WatchChannel";

export default class SubCalendarItem extends BaseObject {

	calendarId: string = null
	calendarName: string = null
	canCheckForConflicts: boolean = false
	canWriteSessions: boolean = false
	hasWritePermission: boolean = false
	isPrimary: boolean = false
	isCalendarMissing: boolean = false

	@Type(() => WatchChannel)
	watchChannel: WatchChannel = null
	isWatchChannelNeedsUpdate: boolean = true


	constructor(calendarId: string = null, calendarName: string = null, hasWritePermission: boolean = false, canCheckForConflicts: boolean = false, isPrimary: boolean = false) {
		super();
		this.calendarId = calendarId;
		this.calendarName = calendarName;
		this.canCheckForConflicts = canCheckForConflicts;
		this.hasWritePermission = hasWritePermission;
		this.isPrimary = isPrimary
	}

	setCanWriteSessions(canWrite){
		if(canWrite){
			this.isWatchChannelNeedsUpdate = true
		}
		this.canWriteSessions = canWrite
	}

	getIsWatchChannelNeedsUpdate(){
		if(!this.canWriteSessions){
			return false
		}
		if(!this.watchChannel){
			return true
		}

		return this.watchChannel.isExpiringSoon() || this.isWatchChannelNeedsUpdate
	}

	setWatchChannel(channelItem){
		this.watchChannel = channelItem
		this.isWatchChannelNeedsUpdate = false
	}
}
